import { Box, Button, IconButton, Typography } from "@mui/material";
import AppBarContainer from "../../components/shared/AppBarContainer";
import PageContentContainer from "../../components/shared/PageContentContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useEffect, useRef, useState } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { useTheme } from "@mui/material/styles";
import Countdown from "react-countdown";
import { useLocation, useNavigate } from "react-router-dom";
import { useRequest } from "../../api/utils/useRequest";
import { BalootUserV2APIs } from "../../api/APIs";
import { useSnackBar } from "../../context/SnackBarContext";
import { setAuthStatus } from "../../store/actions/AuthActions";
import { useDispatch, useSelector } from "react-redux";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { LoadingButton } from "@mui/lab";
import AuthStatusBox from "../../components/auth/AuthStatusBox";
import BalootOTPInput from "../../components/shared/BalootOTPInput";
import { sendPassSejamSuccessfully } from "../../metrix/metrixWrapper";

function SejamOTPConfirmPage() {
  const dispatch = useDispatch();
  const openSnack = useSnackBar();
  const navigate = useNavigate();
  const location = useLocation();
  const nationalId = location.state?.nationalId || "1111111111";
  const theme = useTheme();
  const countdown = useRef(null);
  const [timerCompleted, setTimerCompleted] = useState(false);
  const [timerDate, setTimerDate] = useState(Date.now() + 120000);
  const [timerKey, setTimerKey] = useState(1);
  const [otp, setOtp] = useState("");
  const authStatusMessage = useSelector(
    (state) => state.auth.authStatusMessage
  );

  const { apiCall: sejamStatusCheck, loading: resendLoading } = useRequest(
    BalootUserV2APIs.sejamStatusCheck
  );
  const { apiCall: shahkarCheck, loading: shahkarLoading } = useRequest(
    BalootUserV2APIs.shahkarCheck
  );

  const { apiCall: sejamOtpCheck, loading: sejamLoading } = useRequest(
    BalootUserV2APIs.sejamOtpCheck
  );

  const handleSubmit = () => {
    sejamOtpCheck({
      data: { nationalId, otp },
      onSuccess: (response) => {
        if (response.status === "AUTHENTICATED") {
          if (!process.env.REACT_APP_BASE_URL.includes("dev")) {
            sendPassSejamSuccessfully({ is_successfully: "true" });
          }
          navigate("../referral", { replace: true });
          dispatch(setAuthStatus({}));
        } else {
          dispatch(setAuthStatus({ page: "SejamStatus", data: response }));
          navigate("../sejam-status", { replace: true });
        }
      },
      onError: (error) => {
        if (
          error.data?.errorKey === "sejamExpiredOtp" ||
          error.data?.errorKey === "rateLimit" ||
          error.data?.errorKey === "sejamInvalidOtp"
        ) {
          dispatch(
            setAuthStatus({
              page: "SejamOTP",
              data: {
                title: error.data.title,
                body: error.data.message,
                buttonTitle: "ثبت‌نام به صورت عادی",
                buttonAction: () => {
                  navigate("../personal-info/first-name", { replace: true });
                  dispatch(setAuthStatus({}));
                },
              },
            })
          );
        } else if (error.data?.errorKey === "sejamInvalidStatus") {
          dispatch(
            setAuthStatus({
              page: "SejamOTP",
              data: {
                title: "خطا در سرویس سجام",
                body: "سرویس سجام در حال حاضر در دسترس نیست. اگر تمایل دارید فرآیند ثبت نام را به صورت عادی ادامه دهید.",
                buttonTitle: "ثبت‌نام به صورت عادی",
                buttonAction: () => {
                  navigate("../personal-info/first-name", { replace: true });
                  dispatch(setAuthStatus({}));
                },
              },
            })
          );
        }
      },
    });
  };

  const resendOtp = () => {
    sejamStatusCheck({
      data: { nationalId },
      onSuccess: (response) => {
        setTimerKey((prev) => prev + 1);
        countdown.current.start();
      },
      onError: (error) => {
        if (error.data?.errorKey === "sejamInvalidStatus") {
          setAuthStatus({
            page: "SejamOTP",
            data: {
              title: "خطا در سرویس سجام",
              body: "سرویس سجام در حال حاضر در دسترس نیست. اگر تمایل دارید فرآیند ثبت نام را به صورت عادی ادامه دهید.",
              buttonTitle: "ثبت‌نام به صورت عادی",
              buttonAction: () => {
                navigate("../personal-info/first-name", { replace: true });
                dispatch(setAuthStatus({}));
              },
            },
          });
        } else {
          openSnack(true, { message: error.message });
        }
      },
    });
  };

  const proceedWithShahkar = () => {
    shahkarCheck({
      data: { nationalId },
      onSuccess: (response) => {
        if (response.verified) {
          navigate("../personal-info/first-name", { replace: true });
          dispatch(setAuthStatus({}));
        } else {
          dispatch(setAuthStatus({ page: "NationalId", data: response }));
          navigate(-1);
        }
      },
    });
  };

  useEffect(() => {
    if (otp.length === 5) {
      handleSubmit();
    }
  }, [otp]);

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton
            onClick={() => {
              navigate(-1);
            }}
          >
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            استعلام وضعیت سجام
          </Typography>
        }
      />
      <PageContentContainer sx={{ overflow: "auto" }}>
        <Box>
          <Typography
            component={"div"}
            variant="body1"
            color={"grey.4"}
            align="center"
          >
            کد تاییدی به شماره‌ای که با آن در سامانه سجام ثبت‌نام کرده‌اید ارسال
            شده است، کد را وارد کنید{" "}
          </Typography>
          <Box
            sx={{
              mt: "12px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              direction: "ltr",
            }}
          >
            <BalootOTPInput otp={otp} setOtp={setOtp} />
          </Box>
          <Box
            sx={{
              mt: "24px",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: !timerCompleted ? "flex" : "none",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <CountdownCircleTimer
                size={28}
                key={timerKey}
                strokeWidth={2}
                isPlaying
                duration={120}
                colors={[[theme.palette.grey[2], 1]]}
              />
              <Countdown
                ref={countdown}
                date={timerDate}
                renderer={({ minutes, seconds, completed }) => {
                  return (
                    <Box display="flex" justifyContent="flex-end" mt={1}>
                      <Typography variant="body1" color={"grey.2"}>
                        {("00" + minutes).slice(-2)}:
                        {("00" + seconds).slice(-2)}
                      </Typography>
                    </Box>
                  );
                }}
                onComplete={() => setTimerCompleted(true)}
                onStart={() => {
                  setTimerDate(Date.now() + 120000);
                  setTimerCompleted(false);
                }}
              />
            </Box>
            <LoadingButton
              loading={resendLoading}
              sx={{
                display: timerCompleted ? "block" : "none",
              }}
              variant="text"
              size="small"
              onClick={resendOtp}
            >
              ارسال مجدد کد تایید
            </LoadingButton>
          </Box>
        </Box>
        <Box
          sx={{
            flex: 1,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            mt: 2,
          }}
        >
          <Box>
            {authStatusMessage.page === "SejamOTP" && (
              <AuthStatusBox
                loading={shahkarLoading}
                title={authStatusMessage.data?.message.title}
                body={authStatusMessage.data?.message.body}
                buttonTitle={authStatusMessage.data.buttonTitle}
                buttonAction={authStatusMessage.data.buttonAction}
              />
            )}
            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <LoadingButton
                disabled={otp.length < 5}
                onClick={handleSubmit}
                loading={sejamLoading}
                variant="contained"
                color="primary"
                sx={{ height: 56, width: 48 }}
              >
                <ArrowBackIcon sx={{ color: "common.white", fontSize: 24 }} />
              </LoadingButton>
            </Box>
          </Box>
        </Box>
      </PageContentContainer>
    </>
  );
}

export default SejamOTPConfirmPage;
